import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { PlayerAdjustmentService } from '../../../../services';
import { CardDetail } from '../../../../models';
import { AlertService } from '../../../../services/alert.service';

@Component({
  selector: 'app-payment-type',
  templateUrl: './payment-type.component.html',
  styleUrls: ['./payment-type.component.css']
})
export class PaymentTypeComponent implements OnInit, OnChanges {

  @Input() clubUserProgramFeeId: number;
  @Input() userId: number;

  cache: any = {};
  cards: CardDetail[] = [];
  activeCard: number;
  isCard: boolean;

  constructor(
    private feeService: PlayerAdjustmentService,
    private alertService: AlertService
  ) { }

  ngOnInit() {
  }

  ngOnChanges(data) {
    if (data.userId && this.userId) {
      if (this.cache[this.userId]) {
        this.cards = this.cache[this.userId];
      } else {
        this.feeService.getSavedCardsDetails(this.userId).subscribe(cards => {
          this.cards = cards;
          this.cache[this.userId] = cards;
        });
      }
    }

    if (data.clubUserProgramFeeId && this.clubUserProgramFeeId) {
      this.feeService.getActiveUserCardID(this.clubUserProgramFeeId).subscribe(c => {
        this.activeCard = c;
        this.isCard = !!this.activeCard;
      });
    }
  }

  getCardTypeIcon(type: string) {
    switch (type) {
      case 'Visa':
        return 'visa';
      case 'Master':
      case 'MasterCard':
        return 'mastercard';
      case 'American Express':
        return 'amex';
      case 'Diners Club':
        return 'diners-club';
      case 'JCB':
        return 'jcb';
      case 'Discover':
        return 'discover';
    }
  }

  onCardTypeChanged() {
    if (!this.isCard) {
      this.feeService.deactivatedUserCardID(this.clubUserProgramFeeId).subscribe(
        () => {
          this.alertService.success('Payment type was changed to Mail In Payment');
        },
        () => {
          this.alertService.error('Something went wrong. Try it again later.');
        }
      );
    } else {
      this.onCardChanged();
    }
  }

  onCardChanged() {
    if (this.activeCard) {
      this.feeService.changeUserCard(this.clubUserProgramFeeId, this.activeCard).subscribe(
        () => {
          this.alertService.success('Default credit card was updated');
        },
        () => {
          this.alertService.error('Something went wrong. Try it again later.');
        }
      );
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/member-billing-info/payment-type/payment-type.component.ts